
import React from 'react';
import ContentSection from './ContentSection';

export const BreakthroughStory = () => {
  return (
    <ContentSection title="The Break Through:">
      <p>10X our email, 10X our data.</p>
      
      <p>I researched scalable infrastructure but almost everything required a month of warm up.</p>
      
      <p>I looked through Apollo, ZoomInfo and other data providers but they were too expensive at scale.</p>
      
      <p>I tore apart email templates for capital raising.</p>
      
      <p>In the end, we reverse engineered email infrastructure capable of 100,000 emails a day without warm up.</p>
      
      <p>Found lowkey data brokers who provide millions of records at 30X the cost of "Big Data"</p>
      
      <p>And tested to find the winning system that booked 120 meetings with:</p>
      
      <ul className="list-disc pl-6 space-y-2 mt-4 text-gray-700">
        <li>a16z</li>
        <li>Ledger</li>
        <li>Sequoia</li>
        <li>Opera Browser</li>
        <li>Microsoft</li>
        <li>And other "Blue Chips"</li>
      </ul>
    </ContentSection>
  );
};

export const SiliconValleyStory = () => {
  return (
    <ContentSection title="How the secretive jackpot of Silicon Valley was cracked by an outsider using cold email:">
      <p>It was desperate. "Tristen, I NEED YOU to make this happen or we are DEAD"!</p>
      
      <p>That night until 4am I made an urgent plan.</p>
      
      <p>We needed 100 VC meetings in 30 days to raise our seed round and survive.</p>
      
      <p>12 Serbian developers needed a salary of $40,000 a month.</p>
      
      <p>Ad and distribution costs were mounting.</p>
      
      <p>Our Harvard MBA needed their monthly cash.</p>
      
      <p>How do we get 100 VC meetings without connections, ad spend or tedious networking?</p>
      
      <p>40 meetings over 9 months was achieved with email, but this wasnt enough.</p>
    </ContentSection>
  );
};

export const TransitionStory = () => {
  return (
    <ContentSection title="The Transition:">
      <p>Although we raised $900,000 the market wasnt willing to pay for our software to eliminate their crypto scams.</p>
      
      <p>570 meetings with our target market in 30 days (all from email) affirmed this.</p>
      
      <p>What they wanted was appointments and growth from email.</p>
      
      <p>So we pivoted to helping business owners achieve ther wildest appointment goals with cold email.</p>
      
      <p>We hit a 7 figure run rate in our 3rd month</p>
      
      <p>Then 3,500 sales meetings in less than a year at less than $10 a meeting.</p>
      
      <p>Low cost email replaced what I spent $800,000 on Paid ads to achieve in the past.</p>
    </ContentSection>
  );
};

export const NextStageStory = () => {
  return (
    <ContentSection title="The Next Stage:">
      <p>Our software Munger AI automates what we do manually, if you see this youre on the waitlist.</p>
      
      <p>So the curtain can now unveil!</p>
      <p>For $100 all the secrets of how for less than 10 hours a week of work we've done 6,500 meetings (and counting).</p>
      
      <p>All with cold email.</p>
      
      <p className="italic">Disclaimer: Over a dozen clients literally paid us $25,000 each for this same information.</p>
      
      <p>Only on this page, can you get the cold email secrets we leveraged over 2 years to do millions in sales using only email as the appointment system.</p>
    </ContentSection>
  );
};
